import * as React from 'react';
import { isBoolean, isNumber, isString } from 'lodash';
import { toJS } from 'mobx';
import * as draftToHtml from 'draftjs-to-html';
import { inject } from 'mobx-react';
import { IInjectedProps } from '../../interface/component/injected-props.interface';
import { DesignObjectMentionMetadataType } from '../../enum/page-mention-metadata-type.enum';
import * as moment from 'moment';
import styled from 'styled-components';
import { ellipsisText } from '../../util/style/ellipsis-text.util';
import { renderDraftToHTML } from '../../util/draft/render-draft-to-html.util';
import { AppStateModel } from '../../model/app-state.model';
import { DraftMentionFormatterType } from '../../interface/draft/draft-mention-formatter.type';
import { formatRichTextToHTML } from '../../util/string/format-rich-text-to-html';
import {CustomFontsInclusions} from '../../util/block/custom-fonts-inclusions.util';

type AmbiguousDraftMentionFormatterType = {
  [key in DesignObjectMentionMetadataType]?: (value: any) => string;
};

export interface IDraftToHtmlProps {
  draft: any;
  dataItem?: any;
  inEditor: boolean;
  ellipsis?: boolean;
  blockMentionData?: { [ key: string ]: any };
  mentionFormatter?: AmbiguousDraftMentionFormatterType & DraftMentionFormatterType;
}

export const defaultFormatter: DraftMentionFormatterType = {
  date: (date: string) => moment.utc(date).format('YYYY-MM-DD'),
  html: (html: string, state: AppStateModel) => formatRichTextToHTML(html, state.configuration.CMSUrl)
};

const DraftToHtmlContainer = styled.div`
  width: 100%;
`;

const DraftToHtmlContainerEllipsis = styled(DraftToHtmlContainer)`
  width: 100%;
  & span {
    ${ellipsisText};
    display: inline-block;
    width: 100%;
    margin-top: 38px;
  }
`;

@inject('state', 'dispatch')
export class DraftToHtml extends React.Component<IDraftToHtmlProps & IInjectedProps> {
  onLink = (event) => {
    const link = event.target.getAttribute('href');
    const target = event.target.getAttribute('target');
    if (!target || target === '_self') {
      event.preventDefault();
      this.props.dispatch.redirectPage(link);
    } else {
      this.props.dispatch.openNewTab(link);
    }
  }

  onHTMLClick = (event) => {
    if (event.target.tagName === 'A') {
      this.onLink(event);
    }
  }

  render() {
    if (!this.props.draft || isString(this.props.draft) || isNumber(this.props.draft) || isBoolean(this.props.draft)) {
      return null;
    }
    let Container = DraftToHtmlContainer;
    if (this.props.ellipsis) {
      Container = DraftToHtmlContainerEllipsis;
    }
    const blockMentionData = this.props.dataItem || this.props.blockMentionData;
    const draftJs = toJS(this.props.draft);
    const html = draftToHtml(draftJs, undefined, undefined, renderDraftToHTML(this.props.state, Object.assign({}, defaultFormatter, this.props.mentionFormatter), this.props.inEditor, blockMentionData));
    return (
      <>
        <CustomFontsInclusions html={html} />
        <Container
          dangerouslySetInnerHTML={{__html: html}}
          onClick={this.onHTMLClick}
        />
      </>
    );
  }
}
